import React from "react";
import SectionDraggable, {
    SectionDraggableProps,
} from "organisms/section-drag-and-drop/section-draggable";

interface ActiveSectionDraggableProps
    extends Omit<SectionDraggableProps, "active"> {}

export const ActiveSectionDraggable = (
    props: ActiveSectionDraggableProps
): JSX.Element => <SectionDraggable active={true} {...props} />;
